import React from 'react';
import { useTranslation } from 'react-i18next';
import {
	PageControlsSection,
	PageShadowWrapper,
	PageStatusScreenContent,
	PageStatusScreenMain,
	PageStyled,
	StatusScreenCircleContainer,
	StatusScreenErrorCode
} from '../../styledComponents';
import Icon from '../ui/icon';
import Page from './Page';
import err from '../../images/error.svg';

interface IProps {
	messageCode?: string;
}

function NotFound({ messageCode = '404' }: IProps) {
	const { t } = useTranslation();
	return (
		<Page shadow={false}>
			<PageStyled>
				<PageStatusScreenMain>
					<PageStyled>
						<PageStatusScreenContent>
							<StatusScreenCircleContainer type="warning">
								<Icon img={err} rotating={false} />
							</StatusScreenCircleContainer>
							<span>{t('page_not_found')}</span>
							<StatusScreenErrorCode>{`${t('error')}: ${messageCode}`}</StatusScreenErrorCode>
						</PageStatusScreenContent>
					</PageStyled>
				</PageStatusScreenMain>
				<PageControlsSection notEmpty={false}>
					<PageShadowWrapper />
				</PageControlsSection>
			</PageStyled>
		</Page>
	);
}

export default NotFound;
